import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormInputField from '../FormInputField'

const GitOptionCommitSha = ({ commitSha = null, onChange }) => {
  const { t } = useTranslation('ProjectsPage')

  return (
    <div className="d-flex flex-row justify-content-between">
      <div className="d-flex flex-column justify-content-center">
        {t('GitOptions.options.commitSha.heading')}
      </div>

      <FormInputField
        inputId="commit-sha"
        inputName="commitSha"
        intputStyle={{
          width: '300px'
        }}
        onChange={({ target: { value } }) => onChange(value)}
        value={commitSha || ''}
        withoutFormGroup
      />
    </div>
  )
}

GitOptionCommitSha.propTypes = {
  commitSha: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

export default GitOptionCommitSha
